//import { srchv3util } from 'api/srch-v3/srch-v3-util';
import { IfSrchV3Item } from 'api/srch-v3/srch-v3-model';
import { useApiSrchV3Infinite } from 'api/srch-v3/useApiSrchV3Infinite';
import { openSrchV3 } from 'conf/gconf';
import { DOC_TYPE, getDocTypeName } from 'definitions/DocType';
import { SsqImages } from 'images/SsqImages';
import { tsrch } from 'language/i18nkey';
import { useNavigate } from 'react-router-dom';
import { KNOWLEDGE_BASE_DOC_TYPES } from 'search3/search-tabs';
import svcs from 'services';
import { fontFamilyBold } from 'style/fonts';
import styled from 'styled-components';
import { sanitize } from 'util/commonUtils';
import { docurl } from 'util/ssqutil';
import { useZstdSrch } from './useZstdSrch';

export const InputAssistKnowledge = () => {
  const { inputTmp: input } = useZstdSrch();
  const isSrchV3Mode = openSrchV3;
  const enabled = isSrchV3Mode && !!input?.trim();

  const { list } = useApiSrchV3Infinite(enabled, {
    query: input,
    indexsize: 5,
    page: 1,
    totalsize: 5,
    index: 'all',
    filter: {
      docType: KNOWLEDGE_BASE_DOC_TYPES as DOC_TYPE[],
      exposeSiteLanguage: svcs.svcLang.lang(),
      displayTarget: [0, 10],
      categoryId: [],
      tag: [],
    },
  });

  const navigate = useNavigate();
  const handleClick = (item: IfSrchV3Item) => {
    //console.log('handleClick', item);
    const url = docurl(item.doc_type as DOC_TYPE, item.id);
    const openNewTab = true;
    if (openNewTab) {
      window.open(url, '_blank');
    } else {
      navigate(url);
    }
  };

  if (!isSrchV3Mode) return null;
  if (!list?.length) return null;

  return (
    <Body>
      <SectionTitle>{tsrch('i18n_search_document_search')}</SectionTitle>
      {list.map((item) => (
        <Item key={item.id} onClick={() => handleClick(item)}>
          <img src={SsqImages.common.icon.relatedSuggestResultIcon()} alt='' />
          <DocTypeLabel>{getDocTypeName(item.doc_type ?? '')}</DocTypeLabel>
          <DocTitle dangerouslySetInnerHTML={{ __html: sanitize(item.doc_title ?? '') }} />
        </Item>
      ))}
    </Body>
  );
};

const SectionTitle = styled.div`
  margin-bottom: 0.2rem;
`;

const DocTypeLabel = styled.span`
  flex-shrink: 0;
  width: 7.4rem;
  color: #909fb7;
  font-size: 1rem;
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const DocTitle = styled.div`
  flex: 1;
  min-width: 0;
  ${fontFamilyBold};
  color: #2a2c2f;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  .search_highlight {
    color: #909fb7;
    background: none !important;
    font-weight: inherit;
  }
`;

const Item = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6rem;
  font-size: 1.3rem;
  line-height: 3.2rem;
  color: #2a2c2f;
  cursor: pointer;
  /* 호버 하이라이트를 패널 끝까지 꽉 차게 (컨테이너 좌우 패딩 0.8rem 상쇄) */
  margin: 0 -0.8rem;
  padding: 0 0.8rem;

  img {
    flex-shrink: 0;
    vertical-align: middle;
  }

  &:hover {
    background: #407edb1a;
  }
`;

const Body = styled.div`
  box-sizing: border-box;
  border-top: 1px solid #dde2e9;
  width: 100%;
  padding: 0.8rem;
  text-align: left;
  font-size: 1rem;
  color: #909fb7;
`;
